import React from 'react'

import { PaginatedTable, PaginatedTableCallbacks, useTableUrlSync } from '../common'
import { SuppliersTable } from './collectionTable'
import { JsonSupplier, Supplier } from '../../models'
import { GetSupplierParams, getSuppliers } from '../../api'

export const SuppliersPendingPaymentLanding = () => {
    const tableUrlSync = useTableUrlSync()

    return (
        <PaginatedTable<Supplier, JsonSupplier>
            getData={(params: GetSupplierParams) =>
                getSuppliers({
                    ...params,
                    pendingPayment: true,
                })
            }
            modelConstructor={(json: JsonSupplier) => new Supplier(json)}
            searchPlaceholder="Search by Supplier Name, Phone, or Fax"
            defaultSearch={tableUrlSync.defaultSearch}
            defaultPage={tableUrlSync.defaultPage}
            persistSearch={tableUrlSync.persistSearch}
            onParamsChange={tableUrlSync.onParamsChange}
            Table={(suppliers: Supplier[], callbacks: PaginatedTableCallbacks) => (
                <SuppliersTable callbacks={callbacks} resources={{ suppliers }} />
            )}
            title="Suppliers with Records Pending Payment"
        />
    )
}
